import { Link } from "react-router-dom";
import NewsCard from "@/components/base/NewsCard";
import { newsList } from "@/mocks/news";
import { movies } from "@/mocks/movies";

export default function HomeSidebar() {
  const [leadNews, ...restNews] = newsList;
  const ranking = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 5);

  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
            <span className="h-4 w-1 rounded-full bg-accent-500" />
            影视资讯
          </h2>
          <Link
            to="/news"
            className="flex cursor-pointer items-center gap-0.5 font-label text-xs text-foreground-500 transition-colors hover:text-primary-600"
          >
            更多
            <i className="ri-arrow-right-s-line text-sm" />
          </Link>
        </div>

        <Link to={`/news/${leadNews.id}`} className="group mt-4 block cursor-pointer">
          <div className="aspect-[16/9] w-full overflow-hidden rounded-md bg-background-200">
            <img
              src={leadNews.image}
              alt={`${leadNews.title} 配图`}
              title={`${leadNews.title} - 影视资讯`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <span className="mt-3 inline-block rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">
            {leadNews.category}
          </span>
          <h3 className="mt-2 line-clamp-2 text-sm font-semibold leading-6 text-foreground-950 transition-colors group-hover:text-primary-600">
            {leadNews.title}
          </h3>
        </Link>

        <div className="mt-2">
          {restNews.slice(0, 4).map((item) => (
            <NewsCard key={item.id} item={item} variant="compact" />
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
            <span className="h-4 w-1 rounded-full bg-primary-500" />
            本周口碑榜
          </h2>
          <Link
            to="/category?sort=score"
            className="flex cursor-pointer items-center gap-0.5 font-label text-xs text-foreground-500 transition-colors hover:text-primary-600"
          >
            榜单
            <i className="ri-arrow-right-s-line text-sm" />
          </Link>
        </div>

        <ol className="mt-3">
          {ranking.map((movie, position) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex cursor-pointer items-center gap-3 border-b border-background-200 py-2.5 last:border-b-0"
              >
                <span
                  className={[
                    "w-5 shrink-0 font-label text-sm font-bold",
                    position === 0 ? "text-accent-600" : "text-foreground-300",
                  ].join(" ")}
                >
                  {String(position + 1).padStart(2, "0")}
                </span>
                <div className="h-14 w-10 shrink-0 overflow-hidden rounded bg-background-200">
                  <img
                    src={movie.poster}
                    alt={`${movie.title} 封面`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                    {movie.title}
                  </p>
                  <p className="mt-0.5 truncate text-[11px] text-foreground-500">
                    {movie.genres.slice(0, 2).join(" / ")}
                  </p>
                </div>
                <span className="shrink-0 font-label text-xs font-semibold text-accent-600">{movie.rating.toFixed(1)}</span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg bg-primary-950 p-5 text-background-50">
        <p className="font-label text-[10px] tracking-[0.26em] text-primary-400">EDITOR&apos;S NOTE</p>
        <p className="mt-3 text-sm leading-7 text-background-100/90">
          「我们相信，一部好作品值得被认真讲清楚。这里没有夸张的标题，只有剧情、人物和它们留下的余味。」
        </p>
        <p className="mt-3 text-xs text-primary-300">—— 姐姐的朋友 编辑部</p>
        <Link
          to="/about"
          className="mt-4 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-3 py-2 text-xs font-semibold text-primary-950 transition-colors hover:bg-accent-400"
        >
          了解我们
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      </div>
    </aside>
  );
}